import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import cartConfig from 'emun.cart/cart.config'
import templateUrl from 'emun.cart/cart-additional-customer-info.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'

class controller {
    constructor(options) {
        const $ctrl = this;
        basicController($ctrl);
        $ctrl.bus = new ServiceBus();
        $ctrl.config = cartConfig;
        $ctrl.title = options.title || `Additional Customer Info`;
		var retailerQuery = new AutoQuery({
			url: 'QueryRetailers.json?Id=' + options.customerId,
			orderBy: 'CompanyName',
			autoLoad: true,
			onLoaded: function (args) {
				$ctrl.customer = args.first;
			}
		});
    }
}

export default (options) => modals.open(Object.assign({
    size: options.size || 'md',
    templateUrl,
    resolve: {
        options: () => options
    },
    bindToController: true,
    controller,
    controllerAs: '$ctrl'
}, (options || {}).modal)).result;